import { stageService } from '../../services'

// initial state
const state = () => ({
  stages: [],
  stage: null
})

// actions
const actions = {
  async getStages({ commit, rootState }, eventId) {
    if (!eventId) {
      eventId = rootState.event?.activeEvent?.id
    }
    await stageService.getStages(eventId).then(
      (stages) => {
        commit('getStagesSuccess', stages)
      },
      (error) => {
        commit('getStagesFailure', error)
      }
    )
  },
  getStagesTemplate({ commit }, eventId) {
    return stageService.getStagesTemplate(eventId).then(
      (stages) => {
        commit('getStagesSuccess', stages)
        return JSON.parse(JSON.stringify(stages))
      },
      (error) => {
        commit('getStagesFailure', error)
      }
    )
  },
  getStage({ commit }, stageId) {
    stageService.getStage(stageId).then(
      (stage) => {
        commit('getStageSuccess', stage)
      },
      (error) => {
        commit('getStageFailure', error)
      }
    )
  },
  createStage({ commit, dispatch }, stageData) {
    stageService.createStage(stageData).then(
      (stage) => {
        commit('getStageSuccess', stage)
        dispatch('getStages')
      },
      (error) => {
        commit('getStageFailure', error)
      }
    )
  },
  updateStage({ commit, dispatch }, { stageId, stageData }) {
    stageService.updateStage(stageId, stageData).then(
      (stage) => {
        commit('getStageSuccess', stage)
        dispatch('getStages')
      },
      (error) => {
        commit('getStageFailure', error)
      }
    )
  },
  deleteStage({ commit, dispatch }, stageId) {
    stageService.deleteStage(stageId).then(
      (stage) => {
        commit('getStageSuccess', stage)
        dispatch('getStages')
      },
      (error) => {
        commit('getStageFailure', error)
      }
    )
  }
}

// mutations
const mutations = {
  getStagesSuccess(state, stages) {
    state.stages = stages
  },
  getStageSuccess(state, stage) {
    state.stage = stage
  },
  getStagesFailure(state, error) {
    console.log(state, error)
  },
  getStageFailure(state, error) {
    console.log(state, error)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
